<template>
  <v-list-tile-action class="clear-tile-action" v-if="activeMappedItem && showingMappedValues">
    <v-tooltip bottom>
      <template #activator="{ on }">
        <v-btn v-on="on" @click="remove" icon :loading="loading">
          <v-icon color="grey">clear</v-icon>
        </v-btn>
      </template>
      <span>Remover "{{value}}" del mapeo "{{activeMappedItem.mapped}}"</span>
    </v-tooltip>
  </v-list-tile-action>
</template>

<script>
import { mapActions, mapState } from "vuex";

/**
 * A component to remove a value from a mapped group and its record in the database.
 */
export default {
  props: {
    /* The value to delete */
    value: {
      type: String,
      required: true
    }
  },
  data: () => ({
    loading: false
  }),
  computed: {
    ...mapState("valueMapping", ["activeMappedItem", "showingMappedValues"])
  },
  methods: {
    ...mapActions("valueMapping", ["removeValue"]),
    async remove() {
      this.loading = true;
      await this.removeValue(this.value);
      this.loading = false;
    }
  }
};
</script>

<style scoped>
.clear-tile-action {
  min-width: 40px;
}
</style>